import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Loading from "../../components/shared/Loading/Loading";

const UserGuard = ({ component }) => {
  const [access, setAccess] = useState(null); // null indicates loading state

  useEffect(() => {
    const validateToken = localStorage.getItem("accessToken");

    if (!validateToken) {
      setAccess(false);
      localStorage.clear();

      return;
    }

    try {
      const decode = jwtDecode(validateToken);
      if (decode.exp < Date.now() / 1000) {
        setAccess(false);
        localStorage.clear();
      } else if (decode.exp > Date.now() / 1000 && decode.role === "agent") {
        setAccess(true);
      } else {
        setAccess(false);
        localStorage.clear();
      }
    } catch (error) {
      // Handle token decoding error
      localStorage.clear();
      setAccess(false);
    }
  }, []); // Empty dependency array ensures this runs only once on mount

  // Show loading state while checking access
  if (access === null) {
    return <div><Loading/></div>; // Or a spinner
  }

  return access ? component : <Navigate to="/" />;
};

export default UserGuard;
